import React from 'react';
import { Popover, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

const EmailAddress = ({ netId, email, title }) => {
  return (
    <Popover content={email} title={`${netId} [${title}]`} trigger="hover">
      <Text type="secondary">
        {netId} [{title}]
      </Text>
    </Popover>
  );
};

EmailAddress.propTypes = {
  netId: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default EmailAddress;
